import { NOTIFICATIONTYPE } from "Store/Notification/ActionTypes";
import { ACTION_TYPE, getActionTypes } from "Store/Shared/Actions/Helpers";
import ACTIONS from "./ActionTypes";

export const fetchLayouts = (): ACTION_TYPE => ({
    types: getActionTypes(ACTIONS.FETCH_LAYOUTS),
    shouldCallAPI: state => state.settings.layouts._forceFetch,
    shouldRequestInBackground: state => state.settings.layouts.ids.length > 0,
    callAPI: {
        url: '/api/settings/layouts'
    }
});

export const patchLayout = (layout_id, body): ACTION_TYPE => ({
    types: getActionTypes(ACTIONS.PATCH_LAYOUT),
    callAPI: {
        method: 'PATCH',
        url: `/api/settings/layouts/${layout_id}`,
        body: body
    },
    notification: {
        [NOTIFICATIONTYPE.SUCCESS]: 'Succesvol aangepast',
        [NOTIFICATIONTYPE.ERROR]: 'Aanpassing mislukt'
    }
});

export const createLayout = (body): ACTION_TYPE => ({
    types: getActionTypes(ACTIONS.CREATE_LAYOUT),
    callAPI: {
        method: 'POST',
        url: `/api/settings/layouts`,
        body: body
    },
    notification: {
        [NOTIFICATIONTYPE.SUCCESS]: 'Succesvol aangemaakt',
        [NOTIFICATIONTYPE.ERROR]: 'Aanmaken mislukt'
    }
})

export const deleteLayout = (id: any): ACTION_TYPE => ({
    types: getActionTypes(ACTIONS.DELETE_LAYOUT),
    callAPI: {
        method: 'DELETE',
        url: `/api/settings/layouts/${id}`
    },
    notification: {
        [NOTIFICATIONTYPE.SUCCESS]: 'Succesvol verwijderd',
        [NOTIFICATIONTYPE.ERROR]: 'Verwijderen mislukt'
    }
})